import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { updateProfitLoss } from '../../../store/Slices/profitLossSlice';
import { SetPLValue } from '../../footer/AccountFooter';

const ProfitLoss = ({ row }) => {
    const allSymbolParams = useSelector((state) => state.symbol.allSymbolParams);
    const dispatch = useDispatch()
    const symbol = useSelector(state => state.updateSymbol.symbols?.[row?.symbolId])
    const refSymbol = useSelector(state => state.updateSymbol?.symbols?.[symbol?.referenceSymbolId]) || null
    const [floatingPL, setFloatingPL] = useState(0);
    const calculateProfitForRow = () => {
        const symbolData = allSymbolParams?.[row.symbolId]
        if (!row) return 0;
        if (!symbol) return 0;
        if (!symbolData) return 0;
        const { amount, side, openPrice, interest } = row;
        const { closeCommissionType } = symbolData;
        const { bid, ask } = symbol

        let currentPrice = side === 1 ? bid : ask;
        let profitLoss;

        const calculateCloseCommission = () => {
             const { closeCommissionValue } = symbolData;
            if (closeCommissionType == 0) {
                return 0
            } else if (closeCommissionType == 1) {
                return amount * symbol.contractSize * currentPrice * 0.01 * closeCommissionValue * (calculateRefValue() || 1);
            } else if (closeCommissionType == 2) {
                // console.log("closeCommissionType", amount)
                return closeCommissionValue * amount;
            } else if (closeCommissionType == 3) {
                return closeCommissionValue;
            } else {
                return 0;
            }
        }

        const calculateRefValue = () => {

            if (!symbolData) return 1; // Default value if symbolData is missing

            const { referenceSymbolCalculationType } = symbolData;

            // **Check if reference symbol is USD**
            if (symbol?.referenceSymbolId == null || symbol?.referenceSymbolId == 0 || refSymbol == null) {
                return 1; // USD reference value is always 1
            }

            // **Apply reference symbol calculation type**
            return referenceSymbolCalculationType === "Division" ? 1 / currentPrice : currentPrice;
        };

        const closeCommission = calculateCloseCommission() || 0
        // console.log("closeCommission", closeCommission)
        if (symbol?.referenceSymbolId == null || symbol.referenceSymbolId == 0 || refSymbol == null) {
            if (side == 1) {
                profitLoss = (currentPrice - openPrice) * symbol.contractSize * amount - closeCommission + interest;
            } else {
                profitLoss = ((openPrice - currentPrice) * symbol.contractSize * amount) - closeCommission + interest
            }
        } else {
            // Add check for zero bid value
            if (!refSymbol?.bid) {
                profitLoss = 0;
            } else {
                if (side == 1) {
                    if (symbol?.referenceSymbolCalculationType == 1) {
                        profitLoss = (((currentPrice - openPrice) * refSymbol?.bid) * symbol?.contractSize * amount) - closeCommission + interest
                    } else {
                        profitLoss = (((currentPrice - openPrice) / refSymbol?.bid) * symbol?.contractSize * amount) - closeCommission + interest
                    }
                } else {
                    if (symbol.referenceSymbolCalculationType == 1) {
                        profitLoss = (((openPrice - currentPrice) * refSymbol?.bid) * symbol?.contractSize * amount) - closeCommission + interest
                    } else {
                        profitLoss = (((openPrice - currentPrice) / refSymbol?.bid) * symbol?.contractSize * amount) - closeCommission + interest
                    }
                }
            }
        }
        // Add safety check for invalid numbers
        const parsedProfitLoss = parseFloat(profitLoss);
        const formattedProfitLoss = !isFinite(parsedProfitLoss) ? "0.00" : parsedProfitLoss.toFixed(2);
        // const formattedProfitLoss = parseFloat(profitLoss)?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        dispatch(updateProfitLoss());
        SetPLValue(row?.id, formattedProfitLoss)
        return formattedProfitLoss
    };
    useEffect(() => {
        const updatedPL = calculateProfitForRow();
        setFloatingPL(updatedPL);
    }, [symbol])

    return (
        <span className={`${floatingPL < 0 ? "red" : "green"}`} >{floatingPL}</span>
    )
}

export default ProfitLoss
